import {
  ChangeDetectionStrategy,
  Component,
  input,
  OnInit,
  output,
  OutputEmitterRef,
  signal,
  WritableSignal,
} from '@angular/core';
import { TRANSLATION_SCOPE, translationProvider } from './assets/i18n/translation.provider';
import { TranslocoDirective } from '@ngneat/transloco';
import { DecimalPipe } from '@angular/common';

@Component({
  selector: 'rx-applications-resend-code',
  standalone: true,
  templateUrl: './resend-code.component.html',
  styleUrls: ['./resend-code.component.scss'],
  providers: [translationProvider],
  imports: [TranslocoDirective, DecimalPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResendCodeComponent implements OnInit {
  TRANSLATION_SCOPE = TRANSLATION_SCOPE;

  readonly resendTime = input<number>();
  codeResent: OutputEmitterRef<void> = output<void>();

  remainingTime: WritableSignal<number> = signal<number>(this.resendTime());

  ngOnInit(): void {
    this.setResendLabel();
  }

  resendCode(): void {
    this.codeResent.emit();
    this.setResendLabel();
  }

  setResendLabel(): void {
    this.remainingTime.set(this.resendTime());
    const interval = setInterval(() => {
      const currentCount = this.remainingTime();
      if (currentCount > 0) {
        this.remainingTime.set(currentCount - 1);
      } else {
        clearInterval(interval);
      }
    }, 1000);
  }
}
